// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-share-link--facebook[data-v-c4fe032c]{background-image:url(/assets-proxy/images/sns/sns-facebook.svg)}", ""]);
// Exports
module.exports = exports;
